<template>
  <div class="popup-form">
    <div
      class="content-form-popup"
    >
      <div class="header-text">
        <div class="back-button-wrapper pointer" @click="closePopup">
          <img class="nav-link-icon filter-primary" src="@/images/modal-close.svg" alt=""/>
        </div>
        <div class="_900 big">
          Úprava bonity
        </div>
        <button form="kids-form" class="w-button saveformBtn" :disabled="saving">
          {{ saving ? "Ukladám..." : "Uložiť" }}
        </button>
      </div>

      <div class="w-form">
          <div class="header-block inline">
            <div>
              <div class="bold noselect">Žiadateľ</div>
              <div class="text-cta justify-content-start" @click="editBonitaOf(applicant, 'Žiadateľ')">EDIT</div>
            </div>
            <img
              src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f37_avatar%20cropped.png"
              loading="lazy"
              alt=""
              class="image-10"
            />
          </div>
          <div class="header-block inline" v-if="coApplicant ? coApplicant : null">
            <div>
              <div class="bold noselect">Spolužiadateľ</div>
              <div class="text-cta justify-content-start" @click="editBonitaOf(coApplicant, 'Spolužiadateľ')">EDIT</div>
            </div>
            <img
              src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f37_avatar%20cropped.png"
              loading="lazy"
              alt=""
              class="image-10"
            />
          </div>
          <div class="sub-popup-wrapper" v-else>
            <client-add-handler :rules="['single']" :client-info="{type: 'Spolužiadateľ'}"/>
          </div>
          <div class="splitter">
            Počítame s celkovým počtom detí {{ totalKids }}
          </div>
          <form id="kids-form" @submit.prevent="saveKidsForm">
            <div class="input-group">
              <label for="deti-pocet-z" class="field-label"
              >Deti len žiadateľa</label
              ><input
              v-model.number="form.kids_applicant_only"
              type="number"
              min="0"
              max="255"
              step="1"
              class="text-input w-input required"
              name="deti-pocet-z"
              id="deti-pocet-z"
              required
            />
            </div>
            <div v-if="coApplicant">
              <div class="input-group">
                <label for="deti-pocet-t" class="field-label"
                >Spoločné deti</label
                ><input
                v-model.number="form.kids_shared"
                type="number"
                min="0"
                max="255"
                step="1"
                class="text-input w-input required"
                name="deti-pocet-t"
                id="deti-pocet-t"
                required
              />
              </div>
              <div class="input-group">
                <label for="deti-pocet-s" class="field-label"
                >Deti len spolužiadateľa</label
                ><input
                v-model.number="form.kids_coapplicant_only"
                type="number"
                min="0"
                max="255"
                step="1"
                class="text-input w-input required"
                name="deti-pocet-s"
                id="deti-pocet-s"
                required
              />
              </div>
            </div>
          </form>
          <div class="section-title">
            <div class="light">
                Každé dieťa zadajte iba do jednej skupiny. Zadajte všetky deti do veku 21 rokov vrátane.
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClientAddHandler from "../ClientAdd/ClientAddHandler";
import { mapGetters } from "vuex";

export default {
  name: "ClientBonitaPicker",
  components: {ClientAddHandler},
  computed: {
    ...mapGetters({
      applicantGetter: "mortgageDetailState/getApplicant",
      coApplicantGetter: "mortgageDetailState/getCoApplicant",
      mortgageGetter: "mortgageDetailState/getMortgage",
    }),
    totalKids () {
      return Number(this.form.kids_applicant_only || 0)
        + Number(this.form.kids_shared || 0)
        + Number(this.form.kids_coapplicant_only || 0);
    },
  },
  watch: {
    applicantGetter (newApplicant) {
      this.applicant = newApplicant;
      this.setFormFromState();
    },
    coApplicantGetter (newCoApplicant) {
      this.coApplicant = newCoApplicant;
      this.setFormFromState();
    },
    mortgageGetter (newMortgage) {
      this.mortgage = newMortgage;
      this.setFormFromState();
    },
  },
  created () {
    this.applicant = this.$store.getters["mortgageDetailState/getApplicant"];
    this.coApplicant = this.$store.getters["mortgageDetailState/getCoApplicant"];
    this.mortgage = this.$store.getters["mortgageDetailState/getMortgage"];
    this.setFormFromState();
  },
  methods: {
    async saveKidsForm () {
      if (this.saving) return;
      this.saving = true;
      try {
        await this.$store.dispatch("mortgageDetailState/saveMortgageChildren", {
          applicant_only_children: this.form.kids_applicant_only,
          shared_children: this.coApplicant ? this.form.kids_shared : 0,
          coapplicant_only_children: this.coApplicant ? this.form.kids_coapplicant_only : 0,
        });
        this.closePopup();
      } finally {
        this.saving = false;
      }
    },
    setFormFromState () {
      if (!this.applicant || !this.mortgage || this.saving) return;
      const shared = this.coApplicant
        ? Number(this.mortgage.pocet_spolocnych_nezaopatrenych_deti || 0)
        : 0;
      const applicantTotal = Number(this.applicant.client_profile.pocet_nezaopatrenych_deti || 0);
      const coapplicantTotal = Number(this.coApplicant?.client_profile?.pocet_nezaopatrenych_deti || 0);
      this.form.kids_shared = shared;
      this.form.kids_applicant_only = Math.max(0, applicantTotal - shared);
      this.form.kids_coapplicant_only = Math.max(0, coapplicantTotal - shared);
    },
    editBonitaOf (client, type) {
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        type: null,
        payload: {client, type},
        component: "ClientBonitaPopUp",
        rules: ["single"],
      });
    },
    closePopup () {
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
  },
  data: () => ({
    saving: false,
    applicant: null,
    coApplicant: null,
    mortgage: null,
    form: {
      kids_applicant_only: 0,
      kids_coapplicant_only: 0,
      kids_shared: 0,
    }
  }),
};
</script>

<style lang="scss" scoped>
.popup {
  width: 34%;
  position: absolute !important;
  top: 0;
  overflow-y: auto;
  transition-duration: 0.5s;
}
</style>
